export default "__VITE_ASSET__BuA4gccf__"